module.exports = __webpack_public_path__ + "img/letterOp.99fc602b.svg";